import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../images/brand.svg';


const Logo = () =>(
    
        <>                
            <Link to="/" className="brandContent">
                <img src={logo} className="logo" alt="XDneo" title="XDneo" />
            </Link>
        </>
    )

export default Logo;